import { render, staticRenderFns } from "./breadcrumbButtons.vue?vue&type=template&id=0fa01014&scoped=true&"
import script from "./breadcrumbButtons.vue?vue&type=script&lang=js&"
export * from "./breadcrumbButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa01014",
  null
  
)

export default component.exports